export default __webpack_public_path__ + "static/media/hemodialysis.1e869931.png";